import {LocalDate, LocalDateTime, LocalTime, ZoneId} from '@js-joda/core';
import {DateTimePickerValue} from '@common-module/app-components/date-controls/date-time-picker/date-time-picker.models';

/** Сохраняет прежнее отличие начального выделения календаря от срока генерации без выбора. */
export class PublicLinkPeriod {
  public readonly startDay: LocalDate;
  public readonly minimum: LocalDateTime;
  public selection: DateTimePickerValue;
  private expiration: LocalDateTime;

  constructor(today: LocalDate) {
    this.startDay = today;
    this.minimum = today.atStartOfDay();
    const dayEnd = LocalTime.of(23, 59, 59, 999000000);
    this.selection = {start: this.minimum, end: today.atTime(dayEnd)};
    this.expiration = today.plusDays(30).atTime(dayEnd);
  }

  public select(value: DateTimePickerValue): void {
    this.selection = value;
    this.expiration = value.end;
  }

  /** Преобразование в момент выполняется только на границе API, в зоне выбора. */
  public expirationIso(zone: ZoneId): string {
    return this.expiration.atZone(zone).toInstant().toString();
  }
}
